import React from "react";
import AboutMe from "../AboutMe";
import Header from "../Header";
import "./style.css";
import bgVideo from "../../assets/bgVideo.mp4";

import placeHolderBg from "../../assets/placeHolderCloud.jpg";

const Top = () => {
  return (
    <div>
      {!navigator.userAgent.match(/ucbrowser/i) && (
        <video
          className="videoss"
          autoPlay
          loop
          muted
          poster={placeHolderBg}
          controlsList="nodownload"
          id={navigator.userAgent.match(/samsung/i) && "vd"}
        >
          <source src={bgVideo} type="video/mp4" />
        </video>
      )}
      <Header />
      <AboutMe />

      {/*  <div className="playerWrapper">
        <ReactPlayer
          className="reactPlayer"
          width="100%"
          height="100%"
          url={bgVideo}
          playing
          muted
          loop
        />
      </div> */}
    </div>
  );
};

export default Top;
